import { hasAnyRoleUtil, isRoleUtil } from "../services/roleService";

export const WALLET_MODULE_ADMIN = "WALLET_MODULE_ADMIN";
export const SERALOGIN_WALLET_ACCESS = "SERALOGIN_WALLET_ACCESS";
export const WALLET_ADMIN = "WALLET_ADMIN";
export const WALLET_PAYMENT_ADMIN = "WALLET_PAYMENT_ADMIN";
export const SERALOGIN_ONLINE_ACCESS = "SERALOGIN_ONLINE_ACCESS";

export const canManageWalletModule = (roleList = []) =>
  isRoleUtil(WALLET_MODULE_ADMIN, roleList);

export const canManageWallet = (roleList = []) =>
  hasAnyRoleUtil([WALLET_MODULE_ADMIN, WALLET_ADMIN], roleList);

export const canManageWalletPayment = (roleList = []) =>
  hasAnyRoleUtil([WALLET_MODULE_ADMIN, WALLET_PAYMENT_ADMIN], roleList);

export const canManageWalletProducts = (roleList = []) =>
  hasAnyRoleUtil(
    [WALLET_MODULE_ADMIN, WALLET_ADMIN, WALLET_PAYMENT_ADMIN],
    roleList
  );

export const canViewWalletModule = (roleList = []) =>
  hasAnyRoleUtil(
    [
      "SERALOGIN_ACCESS",
      SERALOGIN_WALLET_ACCESS,
      WALLET_MODULE_ADMIN,
      WALLET_ADMIN,
      WALLET_PAYMENT_ADMIN
    ],
    roleList
  );
